'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isPast;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isPast.js
// module id = 552
// module chunks = 0